<template>
  <transition name="modal">
    <div
      v-show="visible"
      class="modal-mask"
    >
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <button
              class="x-button"
              @click="close"
            >
              <svg
                id="Capa_1"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="357px"
                height="357px"
                viewBox="0 0 357 357"
                style="enable-background:new 0 0 357 357;"
                xml:space="preserve"
              >
                <g>
                  <g id="close">
                    <polygon
                      points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3
                      214.2,178.5 		"
                    />
                  </g>
                </g>
              </svg>
            </button>
            <slot name="header" />
          </div>
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer">
            <slot name="footer" />

            <div class="modal-buttons">
              <slot name="buttons">
                <button
                  class="modal-default-button"
                  @click="close"
                >
                  {{ buttonText }}
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
    name: 'ModalPopup',
    props: {
      buttonText: {
        type: String,
        default: 'OK'
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visible: false
      }
    },
    methods: {
      close() {
        this.visible = false
        this.$emit('close')
      },
      open() {
        this.visible = true
        this.$emit('open')
      }
    }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  overflow: scroll;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  max-width: 400px;
  margin: 0px auto;
  padding: 1rem;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow:auto;
  max-height: 100%;
}

.modal-container {
  position: relative;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.x-button {
  background: transparent;
  width: 20px;
  height: 20px;
  position:absolute;
  top: 10px;
  right: 10px;
  padding: 0;
}
.x-button svg {
  width: 20px;
  height: 20px;
  fill: black;
}

/* .modal-default-button {
  float: right;
} */

.modal-buttons {
    text-align: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>